<template>
    <div class="detail-wrap">
        <div class="page-main">
            <div class="content">
                <div class="evidence">
                    <div class="box-title">
                        <h4>证据原件</h4>
                        <b @click="downFile" v-if="fileInfo.type==1 && fileInfo.sourceFileUploadType==1 && !fileInfo.isExpired">
                            <i class="el-icon-download"></i>下载
                        </b>
                        <b class="noClick" @click="visible=true" v-else>
                            <i class="el-icon-download"></i>下载
                        </b>
                    </div>
                    <div class="ev-title">{{ fileInfo.modifiedName }}</div>
                    <div class="ev-content">
                        <div
                            class="playFile"
                            v-if="fileInfo.sourceFileUploadType==1 && (fileFormat == 1 || fileFormat == 4)"
                        >
                            <video :src="movUrl" controls v-if="isMov" class="defultVideo"></video>
                            <video-player
                                class="video-player vjs-custom-skin"
                                ref="videoPlayer"
                                :playsinline="true"
                                :options="playerOptions"
                                v-else
                            >
                            </video-player>
                            <p class="ts">*若视频在浏览器中无法正常播放，请下载后在视频播放器中播放。</p>
                        </div>
                        <div class="playFile" v-else-if="fileInfo.sourceFileUploadType==1 &&(fileFormat == 2)">
                            <div class="isAudio">
                                <div
                                    class="audioPlay"
                                    :style="{
                                        backgroundImage: 'url(' + audioLogo + ')',
                                    }"
                                ></div>
                                <van-row
                                    type="flex"
                                    justify="space-between"
                                    class="audioFlex"
                                >
                                    <van-col span="4">
                                        <div class="timeStart" ref="audioCurTime">
                                            00:00
                                        </div>
                                    </van-col>
                                    <van-col span="16">
                                        <audio
                                            :src="fileInfo.applyFilePreviewUrl[0]"
                                            id="audio"
                                            ref="Audio"
                                        ></audio>
                                        <van-slider
                                            v-model="audioMp3Value"
                                            active-color="#3988fe"
                                            @change="onChangeAudio"
                                            ref="progressBarBg"
                                        >
                                            <template #button>
                                                <div class="custom-button">
                                                    <div class="custom-child"></div>
                                                </div>
                                            </template>
                                        </van-slider>
                                    </van-col>
                                    <van-col span="4">
                                        <div class="timeEnd" ref="duration">00:00</div>
                                    </van-col>
                                </van-row>

                                <div class="audioContral">
                                    <div class="audio-box">
                                        <div class="line-wrapper" ref="line">
                                            <div class="line-bg"></div>
                                        </div>
                                    </div>
                                    <van-row type="flex">
                                        <van-col span="7">
                                            <van-row type="flex" justify="left">
                                                <van-col
                                                    span="6"
                                                    @click="onTime('minus')"
                                                >
                                                    <div
                                                        class="houtui"
                                                        :style="{
                                                            backgroundImage:
                                                                'url(' + houtui + ')',
                                                        }"
                                                    ></div>
                                                </van-col>
                                            </van-row>
                                        </van-col>
                                        <van-col span="11">
                                            <van-row type="flex" justify="center">
                                                <van-col span="6">
                                                    <div
                                                        class="bofang"
                                                        :style="{
                                                            backgroundImage:
                                                                'url(' + isPlay + ')',
                                                        }"
                                                        @click="myPlay"
                                                    ></div>
                                                </van-col>
                                            </van-row>
                                        </van-col>
                                        <van-col span="6">
                                            <van-row type="flex" justify="end">
                                                <van-col
                                                    span="6"
                                                    @click="onTime('plus')"
                                                >
                                                    <div
                                                        class="kuaijin"
                                                        :style="{
                                                            backgroundImage:
                                                                'url(' + kuaijin + ')',
                                                        }"
                                                    ></div>
                                                </van-col>
                                            </van-row>
                                        </van-col>
                                    </van-row>
                                </div>
                            </div>
                        </div>
                        <div
                            class="playFile"
                            v-else-if="fileInfo.sourceFileUploadType==1 && (fileFormat == 0 || fileFormat == 3 || fileFormat == 127)"
                        >
                            <van-swipe
                                class="my-swipe"
                                :autoplay="3000"
                                indicator-color="white"
                                @change="getSlideIndex"
                                v-if="imgList.length > 0"
                            >
                                <van-swipe-item
                                    v-for="(item, index) in imgList"
                                    :key="'a' + index"
                                    ><img
                                        class="sourcefile"
                                        :src="item"
                                        v-lazy="item"
                                        @click="prview(index)"
                                /></van-swipe-item>
                            </van-swipe>
                            <div class="playFile" v-else>
                                <img
                                    src="@/assets/images/detail/defultPreviewFileM.png"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div class="noFile" v-else>
                            <img src="@/assets/images/nofile-icon.png" alt="">
                            <p>持有者未上传原件</p>
                        </div>
                        <div class="carouselInfo" v-if="imgList.length > 0 && fileInfo.sourceFileUploadType==1">
                            <p>（点击查看大图）</p>
                            <div class="right">
                                第{{ currentIndex }}张，共{{imgList.length}}张
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="certificate">
                    <div class="box-title">
                        <h4><strong class="timestampR">可信时间戳<sup>&reg;</sup></strong>认证证书</h4>
                        <b @click="downTsa" v-if="fileInfo.type==1"><i class="el-icon-download"></i>下载</b>
                        <b class="noClick" @click="visible=true" v-else>
                            <i class="el-icon-download"></i>下载
                        </b>
                    </div>
                    <div class="tsa-img">
                        <div class="file_tsa" v-if="workSwiperList.length > 0">
                            <img :src="workSwiperList" @click="prviewTsa()" alt="" />
                        </div>
                        <div class="file_tsa" v-else>
                            <img
                                class="imgPdf"
                                src="@/assets/images/detail/defultPreviewTsa.png"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="copybtn" ref="copyBtn" @click="copy" :data-clipboard-text="copyCnt" style="display: none;"></div>
        <van-dialog
            class="myDialog"
            v-model="wxCopy"
            title="提示"
            confirmButtonColor="#008AFF"
            confirmButtonText="知道了"
        >
            <div class="diaCnt">页面地址已复制，请至系统浏览器地址栏中粘贴访问后下载。</div>
        </van-dialog>
        <van-dialog
            class="myDialog"
            v-model="visible"
            title=""
            confirmButtonColor="#008AFF"
            confirmButtonText="我知道了"
        >
            <div class="diaCnt">
                <p class="noDown">如需下载证据或证书，<br>请联系证据持有人开通权限</p>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import { ImagePreview } from "vant";
import { panShareFileInfo,panShareFileDownload } from "@/api/service.js";
import playerOptions from "@/plugins/playOptions";
import { isWeixin } from '@/utils/filter'
import {videoToType} from "@/utils/index"
export default {
    data () {
        return {
            imgList: [],
            workSwiperList: "",
            screenWidth: "1024px",
            userInfo: {},
            fileInfo: {
                fileName:'',
                fileType:0,
                sourceType:'',
            },
            currentIndex: 1,
            showBook: true,
            playerOptions,
            movUrl:'',
            audioPlay: require("@/assets/images/audioPlay.gif"),
            zanLogo: require("@/assets/images/zanLogo.png"),
            bofang: require("@/assets/images/bofang.png"),
            zanting: require("@/assets/images/zanting.png"),
            kuaijin: require("@/assets/images/kuaijin.png"),
            houtui: require("@/assets/images/houtui.png"),
            audioLogo: "",
            percent: 0,
            isPlay: false,
            audioMp3Value: 0,
            Audio: "",
            wxCopy:false,
            copyCnt:'',
            visible:false,
        }
    },
    props:{
        randomKey: { type: String, default: '' },
        fullPath:{ type: String, default: '' },
    },
    components: {},
    created () {
        this.copyCnt=window.location.protocol + '//'+ window.location.host +'/folder/index'+'?randomKey='+this.userInfo.randomKey;
        this.init();
    },
    watch: {
        Audio: function () {
            let self = this;
            if (self.$refs.Audio !== undefined) {
                self.$refs.Audio.addEventListener(
                    "timeupdate",
                    function () {
                        // console.log('开始');
                        self.updateProgress();
                    },
                    false
                );
                self.$refs.Audio.addEventListener(
                    "ended",
                    function () {
                        // console.log('结束');
                        self.audioEnded();
                    },
                    false
                );
            }
        },
    },
    computed: {
        isVideo() {
            if (this.fileInfo.fileName) {
                let path = this.fileInfo.fileName;
                let index = path.lastIndexOf(".");
                let extension = path.substring(index + 1, path.length);
                let arry_format = ["mp4", "3gp", "ogg", "webm","m3u8","mpd","flv", "MP4", "3GP", "OGG", "WEBM","MOV","mov"];
                if(this.fileInfo.sourceType==955740){
                    return true;
                }
                if (arry_format.indexOf(extension) == "-1") {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        isMov(){
            if (this.fileInfo.fileName) {
                let path = this.fileInfo.fileName;
                let index = path.lastIndexOf(".");
                let extension = path.substring(index + 1, path.length);
                let arry_format = ["mov", "MOV"];
                if (arry_format.indexOf(extension) == "-1") {
                    return false;
                } else {
                    return true;
                }
            }else{
                return false;
            }
        },
        fileFormat(){
            // 0图片 1视频 2音频 3图片压缩包 4视频压缩包 127不可预览（默认图）
            // switch (this.fileInfo.fileType) {
            //     case 'IMAGE':
            //         return 0
            //     case 'VIDEO':
            //         return 1
            //     case 'AUDIO':
            //         return 2
            //     case 'IMAGE_ZIP':
            //         return 3
            //     case 'VIDEO_ZIP':
            //         return 4
            //     case 'OTHER':
            //         return 127
            // }
            return this.fileInfo.fileType
        }
    },
    mounted () {},
    methods: {
        async init() {
            try {
                let res = await panShareFileInfo({
                    randomKey:this.randomKey,
                    fullPath:this.fullPath
                });
                this.fileInfo = res;
                this.workSwiperList = [res.pdfThumbnailUrl];
                if(res.sourceFileUploadType===0){
                    this.imgList = res.applyFilePreviewUrl;
                }else{
                    if (this.fileFormat == 0 || this.fileFormat == 3 || this.fileFormat == 127) {
                        this.imgList = res.applyFilePreviewUrl;
                    } else if (this.fileFormat == 1 || this.fileFormat == 4) {
                        if (this.isVideo) {
                            let index = res.fileName.lastIndexOf(".");
                            let extension = res.fileName.substring(
                                index + 1,
                                res.fileName.length
                            );
                            if(this.fileInfo.sourceType==955740){
                                extension='mp4'
                            }
                            if(this.isMov){
                                this.movUrl=res.applyFilePreviewUrl[0]
                            }else{
                                this.playerOptions.sources=[];
                                this.playerOptions.sources.push({
                                    src: res.applyFilePreviewUrl[0],
                                    type: videoToType(extension.toLowerCase()),
                                });
                            }
                            
                        }
                    } else if (this.fileFormat == 2) {
                        this.isAudio = true;
                        this.isPlay = this.bofang;
                        this.audioLogo = this.zanLogo;
                        this.$nextTick(() => {
                            this.Audio = this.$refs.Audio;
                        });
                    } else {
                        this.imgList = [];
                    }
                }
                
            } catch (error) {
                if ([20005,20018,20019,20020].includes(error.code)) {
                    this.fileFormat=0;
                    this.imgList = [];
                    this.workSwiperList=[];
                } else {
                    this.$toast(error.message);
                    this.imgList = [];
                }
            }
        },
        prview(index) {
            ImagePreview({
                images: this.imgList,
                startPosition: index,
                closeable: true,
                maxZoom: 10,
            });
        },
        prviewTsa() {
            ImagePreview({
                images: [this.workSwiperList],
                closeable: true,
                maxZoom: 10,
            });
        },
        onPlayerPlay() {
        },
        // 音频 初始化
        // 音频 播放-暂停
        myPlay() {
            this.Audio = this.$refs.Audio;
            if (this.Audio.paused) {
                this.$refs.Audio.play();
                this.isPlay = this.zanting;
                this.audioLogo = this.audioPlay;
            } else {
                this.$refs.Audio.pause();
                this.isPlay = this.bofang;
                this.audioLogo = this.zanLogo;
            }
        },
        getSlideIndex(current) {
            this.currentIndex = current + 1;
        },
        // 音频 时间转换00:00
        transTime(time) {
            var duration = time;
            var minute = parseInt(duration / 60);
            var sec = Math.round((duration % 60))+ "";
            var isM0 = ":";
            if (minute == 0) {
                minute = "00";
            } else if (minute < 10) {
                minute = "0" + minute;
            }
            if (sec.length == 1) {
                sec = "0" + sec;
            }
            return minute + isM0 + sec;
        },
        //  * 格式化时间显示，补零对齐
        //  * eg：2:4  -->  02:04
        formatTime(value) {
            let time = "";
            let s = value.split(":");
            let i = 0;
            for (; i < s.length - 1; i++) {
                time += s[i].length == 1 ? "0" + s[i] : s[i];
                time += ":";
            }
            time += s[i].length == 1 ? "0" + s[i] : s[i];
            return time;
        },
        // 音频初始化 时间
        updateProgress() {
            let value = this.Audio.currentTime / this.Audio.duration;
            this.audioMp3Value = value * 100;
            // 初始时间
            this.$refs.audioCurTime.innerHTML = this.transTime(
                this.Audio.currentTime
            );
            // 总共时长
            let audioElement = new Audio();
            audioElement.src = this.fileInfo.applyFilePreviewUrl[0];
            let self = this;
            audioElement.addEventListener("loadedmetadata", function () {
                self.$refs.duration.innerHTML = self.transTime(
                    audioElement.duration
                );
            });
            // 播放结束 重新归0
            if (this.Audio.currentTime === this.Audio.duration) {
                this.isPlay = this.bofang;
                this.audioLogo = this.zanLogo;
                this.Audio.currentTime = 0;
            }
        },
        // 进度条change
        onChangeAudio() {
            if (!this.Audio.paused || this.Audio.currentTime != 0) {
                this.Audio.currentTime =
                    (this.Audio.duration * this.audioMp3Value) / 100;
            }
        },

        // 音频 快进 后退 10s
        onTime(type) {
            let time = 10;
            if (!this.Audio.paused || this.Audio.currentTime != 0) {
                type === "minus"
                    ? (this.Audio.currentTime = this.Audio.currentTime - time)
                    : (this.Audio.currentTime = this.Audio.currentTime + time);
            }
        },
        copy() {
            var clipboard = new this.Clipboard('.copybtn')
            var that = this
            clipboard.on('success', (e) => {
                // console.log('复制成功')
                that.wxCopy=true;
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', (e) => {
                // 不支持复制
                console.log('该浏览器不支持自动复制')
                that.$toast('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        async downFile(){
            if(isWeixin()){
                this.$refs.copyBtn.click();
            }else{
                try {
                    let res= await panShareFileDownload({
                        randomKey:this.randomKey,
                        fullPath:this.fullPath
                    });
                    let link = document.createElement("a");
                    link.style.display = "none";
                    link.target = "_blank";
                    link.href = res.applyFileUrl;
                    link.download = res.fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch (error) {
                    this.$toast(error.message);
                }
            }
            
        },
        async downTsa() {
            if(isWeixin()){
                this.$refs.copyBtn.click();
            }else{
                let link = document.createElement("a");
                link.style.display = "none";
                link.target = "_blank";
                link.href = this.fileInfo.pdfUrl;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
            
        },
        
    }
}
</script>

<style src="./css/index.less" scoped lang="less"></style>
